export default __webpack_public_path__ + "static/media/admin_panel_settings.e283775a.svg";